import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
  SHELL_FOOTER_PX,
} from "config";

export default function Footer() {
  const theme = useTheme();
  const year = new Date().getFullYear();

  const linkSx = {
    ...theme.typography.calibrateShell,
    fontSize: { xs: 11, sm: 14 },
    fontWeight: 500,
    color: "rgba(255, 255, 255, 0.92)",
    textDecoration: "none",
    textUnderlineOffset: "3px",
    transition: "color 0.15s ease",
    "&:hover": {
      color: "calibrate.iconOnTeal",
      textDecoration: "underline",
    },
  };

  return (
    <Box
      component="footer"
      role="contentinfo"
      sx={{
        flexShrink: 0,
        height: SHELL_FOOTER_PX,
        minHeight: SHELL_FOOTER_PX,
        maxHeight: SHELL_FOOTER_PX,
        boxSizing: "border-box",
        bgcolor: "primary.main",
        borderTop: "1px solid rgba(255, 255, 255, 0.12)",
        boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.15)",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", lg: 1200 },
          mx: "auto",
          px: { xs: 2, sm: 3, md: "24px" },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          boxSizing: "border-box",
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            ...theme.typography.calibrateShell,
            fontSize: { xs: 11, sm: 14 },
            fontWeight: 500,
            color: "calibrate.navText",
            lineHeight: 1.2,
            opacity: 0.95,
            flex: "1 1 auto",
            minWidth: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            pr: 1,
          }}
        >
          © {year} CalibrateHCM · All rights reserved.
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1, sm: 2 },
            flexShrink: 0,
          }}
        >
          <Link
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={linkSx}
          >
            Privacy Policy
          </Link>

          <Box
            aria-hidden
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              bgcolor: "rgba(255, 255, 255, 0.35)",
              flexShrink: 0,
              display: { xs: "none", sm: "block" },
            }}
          />

          <Link
            href={TERMS_OF_SERVICE_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={linkSx}
          >
            Terms & Conditions
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
